import formatNumber from '../../../../../../../../_dev/frontend/js/commonFunctions/formatNumber';

const productPageSetPrice = () => {
    const elements = {
        colorOption: document.querySelector('.Product-page__row[data-option-id="13"] .Field-select__select'),
        currentPrice: document.querySelector('.Product-page__current-price')
    }

    if (elements.colorOption && elements.currentPrice) {
        elements.colorOption.addEventListener('change', () => {
            const rawPrice = Number(elements.currentPrice.dataset.rawPrice);
            const optionPrice = Number(elements.colorOption.options[elements.colorOption.selectedIndex].dataset.price);
            const newPriceValue = rawPrice + optionPrice;

            elements.currentPrice.dataset.price = newPriceValue;
            elements.currentPrice.querySelector('.Number-value').innerText = formatNumber(newPriceValue);
        });
    }
}

export default productPageSetPrice;
